import SaveIcon from "@mui/icons-material/Check";
import { default as CancelIcon } from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import { IconButton, TextField } from "@vapor/react-material";
import { useEffect, useRef, useState } from "react";
import Button from "../../vapor/button/index";
import { ColorButton } from "../../vapor/tag";
import { extractRandomLabelTagColor, TagColor } from "../../vapor/tag/colors";
import "./style.scss";

interface AddLabelProps {
    addNewLabel: (name: string, color: TagColor) => void;
    presetLabels?: Array<string>;
}

const AddLabel = (props: AddLabelProps): JSX.Element => {
    const [editing, setEditing] = useState(false);
    const [newName, setNewName] = useState("");
    const [colorChoice, setColorChoice] = useState(
        extractRandomLabelTagColor(),
    );
    const errorTooManyChars = newName?.length > 30;
    const isDuplicate = props.presetLabels
        ?.map((pl) => pl.toLowerCase())
        .includes(newName?.toLowerCase());
    const isInErrorState = isDuplicate || errorTooManyChars;

    const inputRef = useRef<HTMLInputElement | null>(null);
    useEffect(() => {
        if (editing && inputRef.current) {
            inputRef.current?.focus();
            inputRef.current?.select();
        }
    }, [editing]);

    const submit = () => {
        props.addNewLabel(newName, colorChoice);
        setNewName("");
        setEditing(false);
    };

    const handleCancelEdit = () => {
        setEditing(false);
        setNewName("");
    };

    return (
        <>
            {editing && (
                <Typography sx={{ fontWeight: 600 }}>
                    Nuova etichetta
                </Typography>
            )}
            <div
                style={{
                    marginRight: "8px",
                    marginTop: "8px",
                    marginBottom: "16px",
                    display: "flex",
                    gap: "8px",
                    alignItems: isInErrorState ? "start" : "center",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {editing ? (
                    <>
                        <ColorButton
                            colorChoice={colorChoice}
                            onChange={(chosenColor: TagColor) => {
                                setColorChoice(chosenColor);
                            }}
                        />
                        <TextField
                            value={newName}
                            placeholder="Nome etichetta"
                            onChange={(e) => setNewName(e.target.value)}
                            onKeyDown={(e) => {
                                if (!isInErrorState && e.key === "Enter") {
                                    submit();
                                }
                                if (e.key === "Escape") {
                                    e.preventDefault();
                                    setEditing(false);
                                }
                            }}
                            error={isInErrorState}
                            helperText={
                                errorTooManyChars
                                    ? "Etichetta deve essere minore di 30 caratteri"
                                    : isDuplicate
                                      ? "Etichetta duplicata"
                                      : ""
                            }
                            size="small"
                            sx={{ flex: 1, mr: 2 }}
                        />

                        <IconButton
                            color="primary"
                            onClick={submit}
                            disabled={!newName.trim() || isInErrorState}
                        >
                            <SaveIcon />
                        </IconButton>
                        <IconButton color="inherit" onClick={handleCancelEdit}>
                            <CancelIcon />
                        </IconButton>
                    </>
                ) : (
                    <>
                        <Button
                            size="medium"
                            onClick={() => {
                                setEditing(true);
                            }}
                        >
                            Crea nuova etichetta
                        </Button>
                    </>
                )}
            </div>
        </>
    );
};

export default AddLabel;
